//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryProjectArchtList } from '@/api/api';
import { getAction } from '@/api/manage';
import OperationReportModal from "./modules/OperationReportModal";
import moment from 'moment'; // import PDFModal from '@comp/PDFView/PDFModal'

export default {
  name: 'OperationReportList',
  mixins: [JeecgListMixin],
  components: {
    // PDFModal
    OperationReportModal: OperationReportModal
  },
  data: function data() {
    return {
      value: [],
      mode2: ['month', 'month'],
      pagePath: '/om/operation/report',
      pageTitle: '运维报告导出记录',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'sysFile.fileName',
        colName: 'fileName',
        // scopedSlots: {
        //   customRender: 'fileName',
        // },
        title: '文件名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'sysFile.createTime',
        colName: 'createTime',
        title: '创建时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'startTime',
        colName: 'start_time',
        title: '开始时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'endTime',
        colName: 'end_time',
        title: '结束时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'siteIds',
        colName: 'site_ids',
        title: '站点',
        align: 'center',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      siteTree: []
    };
  },
  created: function created() {
    this.getSiteTree();
  },
  computed: {},
  methods: {
    searchReset: function searchReset(arg) {
      var _this = this;

      this.queryParam.siteId = '';
      this.value = [];
      this.queryParam.startTime = '';
      this.queryParam.endTime = '';

      if (arg === 1) {
        this.ipagination.current = 1;
      }

      var params = this.getQueryParams(); //查询条件

      getAction('/om/operation/report', params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result.records;
          _this.ipagination.total = res.result.total;
        }
      });
    },

    /* 文件下载 */
    downUploadFile: function downUploadFile(text) {
      if (!text) {
        this.$message_custom('未知的文件', 'warning');
        return;
      }

      window.open(window._CONFIG['domianURL'] + '/sys/common/file/download/' + text);
    },
    //获取站点树
    getSiteTree: function getSiteTree() {
      var _this2 = this;

      getAction('/online/env/api/queryTreeList?addrType=1').then(function (res) {
        if (res.success) {
          _this2.reviseTree(res.result);

          _this2.siteTree = res.result;
        }
      });
    },
    reviseTree: function reviseTree(tree) {
      for (var i = 0; i < tree.length; i++) {
        var node = tree[i];

        if (node.children) {
          node['disabled'] = true;
          this.reviseTree(node.children);
        } else {
          node['disabled'] = false;
        }
      }
    },
    // 时间区间变化
    onallChange: function onallChange(date, dateString) {
      this.queryParam.startTime = dateString[0];
      this.queryParam.endTime = dateString[1];
    },
    handlePanelChange: function handlePanelChange(value, mode) {
      this.value = value;
      this.queryParam.startTime = value[0].format('YYYY-MM');
      this.queryParam.endTime = value[1].format('YYYY-MM');
    },
    openModal: function openModal() {
      this.$refs.operationReportModal.visible = true;
    }
  }
};